var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwiperExerciseActiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,1.785a15,15,0,1,1-15,15A15,15,0,0,1,16.5,1.785Z",
    transform: "translate(-1.497 -1.785)",
    fill: "#add429"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.789,7.85V5.231H4.825V7.85c0,.563-.146,1.02-.65,1.02s-.681-.457-.681-1.02c0-1.706,0-5.123,0-6.83C3.493.457,3.67,0,4.175,0s.65.456.65,1.019V3.907h6.964V1.019c0-.563.173-1.019.678-1.019s.638.456.638,1.019V7.85c0,.563-.133,1.02-.638,1.02S11.789,8.413,11.789,7.85ZM14.5,7.508c-.381,0-.519-.3-.519-.68V2.041c0-.376.138-.679.518-.679h.09a.688.688,0,0,1,.694.68c0,1.182,0,3.6,0,4.786a.688.688,0,0,1-.694.679Zm-12.626,0c-.381,0-.546-.3-.546-.68V2.041a.655.655,0,0,1,.654-.679h.09c.381,0,.542.3.542.68V6.829a.652.652,0,0,1-.651.679ZM15.723,5.451V3.419c0-.188.243-.34.395-.34s.488.153.488.34V5.451c0,.187-.336.34-.488.34S15.723,5.638,15.723,5.451ZM0,5.45c0-.521,0-1.509,0-2.03,0-.188.337-.34.488-.34s.395.153.395.34c0,.521,0,1.511,0,2.031,0,.187-.243.34-.395.34S0,5.638,0,5.45Z",
    transform: "translate(7 11)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiperExerciseActiveIcon);
export default __webpack_public_path__ + "static/media/swiper_exercise_active_icon.6578fc4b.svg";
export { ForwardRef as ReactComponent };